import { render, staticRenderFns } from "./_leagueLog.vue?vue&type=template&id=031bcff8&scoped=true&lang=pug&"
import script from "./_leagueLog.vue?vue&type=script&lang=js&"
export * from "./_leagueLog.vue?vue&type=script&lang=js&"
import style0 from "./_leagueLog.vue?vue&type=style&index=0&id=031bcff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031bcff8",
  null
  
)

export default component.exports